/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Server",
  size: 20
}

const SvgServer = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M3 3h1v2H3zM5 3h1v2H5zM7 3h1v2H7zM16 3h1v1h-1zM16 10h1v1h-1z" />
    <circle fill="none" cx={9.9} cy={17.4} r={1.4} />
    <path d="M3 10h1v2H3zM5 10h1v2H5zM9.5 14h1v2h-1zM3 17h6v1H3zM11 17h6v1h-6z" />
    <path fill="none" d="M1.5 1.5h17v5h-17zM1.5 8.5h17v5h-17z" />
  </Svg>
)

SvgServer.defaultProps = defaultProps
export default SvgServer
